import React from 'react';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import SEO from './SEO';
import { properties } from '../data/properties';

const Home = () => {
  return (
    <div className="home">
      <SEO
        title="Beachfront Villas in Kannur, Kerala | Near the Beach"
        description="Near the Beach curates handpicked beachfront villas on Kannur's coast, starting with Grand Beach Villa on Payyambalam Beach. Browse our properties and explore Kannur's beaches, culture, and things to do."
        keywords="Kannur beach villas, beachfront stay Kannur, Grand Beach Villa, Payyambalam Beach accommodation, Kerala beach resort, where to stay in Kannur, Kannur vacation rental"
        url="https://nearthebeach.in/"
      />
      <Hero
        title="Beachfront Villas in Kannur, Kerala"
        subtitle="Handpicked coastal stays on Kannur's shoreline, starting with Grand Beach Villa"
      />

      <main>
        <section className="properties-section" aria-labelledby="properties-heading">
          <div className="container">
            <h2 id="properties-heading">Our Villas</h2>
            <div className="content-grid properties-grid">
              {properties.map((property) => (
                <div className="content-card property-card" key={property.slug}>
                  <div className="content-card-image">
                    <img src={property.image} alt={property.name} title={property.name} loading="lazy" />
                  </div>
                  <div className="content-card-content">
                    <h3>{property.name}</h3>
                    <p className="property-tagline">{property.tagline}</p>
                    <div className="reviews-summary property-rating">
                      <div className="stars" aria-hidden="true">★★★★★</div>
                      <p className="rating-line">
                        {property.rating.value} out of 5 — {property.rating.count} reviews on Google
                      </p>
                    </div>
                    <div className="content-card-description">
                      <p>{property.blurb}</p>
                    </div>
                    <div className="content-card-links">
                      <Link to={property.route} className="view-details-link">
                        View Details
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
